try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Button } from '@design-system/button';
import { useDomDirection } from '@design-system/hooks';
import { ContentDirection } from '@design-system/types';
import { Link } from '@design-system/link';
import { forwardRef, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import { getCountryData, continents } from 'countries-list';
import ReactCountryFlag from 'react-country-flag';
import { usePopper } from 'react-popper';

try {
  if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');else require('./index.css');
} catch (e) {
  if (e.code !== 'MODULE_NOT_FOUND') {
    throw e; // Re-throw unexpected errors
  }

  console.warn('index.css / index-new.css not found, proceeding without it.');
}
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

const getClassName = _ref => {
  let {
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  } = _ref;
  const isBodyOrHeadlineOrDetail = variant === 'body' || variant === 'headline' || variant === 'detail';
  return classNames('cds-typography', className, {
    [`cds-typography--align-${align}`]: align,
    [`cds-typography--variant-${variant}`]: variant,
    [`cds-typography--variant-${variant}-${size}`]: isBodyOrHeadlineOrDetail && size,
    [`cds-typography--wrapping-${wrapping}`]: wrapping,
    [`cds-typography--weight-${weight}`]: isBodyOrHeadlineOrDetail && weight
  });
};

const unwrapFirstTag = (typographyTag, typographyVariant, typographyContent) => {
  const openTagRegExp = /^<\/?[^>]+(>|$)/g;
  const closeTagRegExp = /<\/[^>]+(>$)/g;
  return typographyVariant !== 'rte' && typographyTag !== 'div' ? typographyContent.toString().replace(openTagRegExp, '').replace(closeTagRegExp, '') : typographyContent;
};

const Typography = /*#__PURE__*/forwardRef((_a, ref) => {
  var {
    content,
    tag = 'div',
    variant,
    align,
    className,
    size = 'm',
    weight = 'regular',
    wrapping = 'break-word',
    link
  } = _a,
      htmlProperties = __rest(_a, ["content", "tag", "variant", "align", "className", "size", "weight", "wrapping", "link"]);

  const LinkElement = (link === null || link === void 0 ? void 0 : link.component) || Link;
  const typographyClassName = getClassName({
    align,
    variant,
    wrapping,
    className,
    size,
    weight
  });
  const Tag = tag && variant !== 'rte' ? tag : 'div';
  const html = unwrapFirstTag(tag, variant, content);
  return link ? jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref
  }, htmlProperties, {
    children: jsx(LinkElement, Object.assign({}, link.props, {
      iconPrefix: undefined,
      iconSuffix: undefined
    }, {
      children: jsx("span", {
        dangerouslySetInnerHTML: {
          __html: html
        }
      })
    }))
  })) : jsx(Tag, Object.assign({
    className: typographyClassName,
    ref: ref,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, htmlProperties));
});

const LanguageLink = ({ countryCode, name, url, ariaLabel, }) => (jsxs(Link, Object.assign({ href: url, className: "cds-language-link", variant: "secondary" }, { children: [jsx(ReactCountryFlag, { className: "cds-language-link__img", countryCode: countryCode, svg: true, title: name, "aria-label": ariaLabel }), jsx(Typography, { tag: "span", size: "s", className: "cds-language-link__link", variant: "body", content: name })] })));

const CountryModal = ({ countries }) => {
    const extendedCountries = countries.map((country) => {
        const extendedCountry = getCountryData(country.countryCode);
        return Object.assign(Object.assign({}, country), { name: extendedCountry.name, continent: extendedCountry.continent });
    });
    const groupedByContinent = extendedCountries.reduce((result, country) => {
        const continent = continents[country.continent];
        if (!continent)
            return result;
        const continentData = result[continent] || [];
        return Object.assign(Object.assign({}, result), { [continent]: [...continentData, country] });
    }, {});
    return (jsx(Fragment, { children: Object.entries(groupedByContinent)
            .sort((a, b) => (a[0] >= b[0] ? 1 : -1))
            .map(([continent, countryArray]) => (jsxs("div", Object.assign({ className: "cds-country-modal__continent" }, { children: [jsx(Typography, { className: "cds-country-modal__continent-headline", variant: "body", size: "l", weight: "bold", content: continent }), jsx("div", Object.assign({ className: "cds-country-modal__continent-list" }, { children: countryArray
                        .sort((a, b) => (a.name >= b.name ? 1 : -1))
                        .map((country) => (jsx(LanguageLink, Object.assign({}, country), country.countryCode))) }))] }), continent))) }));
};

const calculateInnerModalContinentsWidth = (isRtl, continents) => {
    const continentFirstComputed = window.getComputedStyle(continents[0]);
    const continentLastComputed = window.getComputedStyle(continents[continents.length - 1]);
    if (isRtl) {
        return (continents[0].getBoundingClientRect().right -
            continents[continents.length - 1].getBoundingClientRect().left +
            parseInt(continentFirstComputed.paddingRight, 10) +
            parseInt(continentLastComputed.paddingLeft, 10));
    }
    return (continents[continents.length - 1].getBoundingClientRect().right -
        continents[0].getBoundingClientRect().left +
        parseInt(continentFirstComputed.paddingLeft, 10) +
        parseInt(continentLastComputed.paddingRight, 10));
};
const setModalWidth = (ref, parentRef, isRtl) => {
    if (!ref.current || !parentRef.current)
        return;
    const continents = Array.from(ref.current.children).filter((node) => node instanceof HTMLElement);
    if (continents.length === 0)
        return;
    const modalComputed = window.getComputedStyle(ref.current);
    const innerModalContinentsWidth = calculateInnerModalContinentsWidth(isRtl, continents);
    const parentWidth = parentRef.current.getBoundingClientRect().width;
    const innerModalWidth = innerModalContinentsWidth +
        parseInt(modalComputed.paddingLeft, 10) +
        parseInt(modalComputed.paddingRight, 10);
    ref.current.style.width = `${Math.min(parentWidth, innerModalWidth)}px`;
};
const setContinentsWidth = (ref, parentRef, isRtl) => {
    if (!ref.current || !parentRef.current)
        return;
    Array.from(ref.current.children).forEach((continent) => {
        const countries = Array.from(continent.children[1].children).filter((node) => node instanceof HTMLElement);
        if (countries.length === 0)
            return;
        const countriesRightBoundary = Math.max(...countries.map((country) => country.getBoundingClientRect().right));
        const countriesLeftBoundary = Math.min(...countries.map((country) => country.getBoundingClientRect().left));
        const countryComputed = window.getComputedStyle(countries[0]);
        const continentNameWidth = continent.children[0].getBoundingClientRect().width;
        const countriesWidth = countriesRightBoundary -
            countriesLeftBoundary +
            parseInt(countryComputed.marginLeft, 10) +
            parseInt(countryComputed.marginRight, 10);
        const continentComputed = window.getComputedStyle(continent);
        const continentWidth = Math.max(continentNameWidth, countriesWidth) +
            parseInt(continentComputed.paddingLeft, 10) +
            parseInt(continentComputed.paddingRight, 10);
        continent.style.width = `${continentWidth}px`;
    });
    ref.current.style.alignContent = 'flex-start';
    setModalWidth(ref, parentRef, isRtl);
};
const extendModalHeight = (ref, parentRef, isRtl) => {
    if (!ref.current)
        return;
    const modalBoundary = ref.current.getBoundingClientRect()[isRtl ? 'left' : 'right'];
    const continents = Array.from(ref.current.children).filter((node) => node instanceof HTMLElement);
    const heights = continents.map((continent, index) => {
        const continentBoundary = continent.getBoundingClientRect()[isRtl ? 'left' : 'right'];
        const countries = Array.from(continent.children[1].children).filter((node) => node instanceof HTMLElement);
        const modalBoundaryExceeded = isRtl
            ? continentBoundary < modalBoundary
            : continentBoundary > modalBoundary;
        if (modalBoundaryExceeded) {
            const prevContinentComputed = window.getComputedStyle(index > 0 ? continents[index - 1] : continents[index]);
            return (parseInt(prevContinentComputed.height, 10) -
                2 * parseInt(prevContinentComputed.paddingTop, 10));
        }
        return countries
            .filter((country) => {
            if (isRtl) {
                return (country.getBoundingClientRect().left +
                    parseInt(window.getComputedStyle(country).marginLeft, 10) <
                    continentBoundary);
            }
            return (country.getBoundingClientRect().right +
                parseInt(window.getComputedStyle(country).marginRight, 10) >
                continentBoundary);
        })
            .reduce((acc, country) => acc +
            country.offsetHeight +
            parseInt(window.getComputedStyle(country).marginTop, 10) +
            parseInt(window.getComputedStyle(country).marginBottom, 10), 0);
    });
    const modalComputed = window.getComputedStyle(ref.current);
    ref.current.style.maxHeight = `${parseInt(modalComputed.height, 10) + Math.max(...heights)}px`;
    setContinentsWidth(ref, parentRef, isRtl);
};
const addClassToWrappedElements = (ref, isRtl) => {
    var _a;
    if (!ref.current)
        return;
    const continents = Array.from(ref.current.children).filter((node) => node instanceof HTMLElement);
    const firstItemBoundary = (_a = continents[0]) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()[isRtl ? 'right' : 'left'];
    continents.forEach((item) => {
        const itemBoundary = item.getBoundingClientRect()[isRtl ? 'right' : 'left'];
        item.classList.toggle('wrapped', itemBoundary !== firstItemBoundary);
    });
};
const focusFirstCountryLink = (ref) => {
    var _a, _b;
    const continentContainer = (_a = ref === null || ref === void 0 ? void 0 : ref.current) === null || _a === void 0 ? void 0 : _a.firstChild;
    if (continentContainer instanceof Element) {
        const firstLink = (_b = continentContainer.querySelector('.cds-country-modal__continent-list')) === null || _b === void 0 ? void 0 : _b.firstChild;
        if (firstLink && firstLink instanceof HTMLAnchorElement)
            firstLink.focus();
    }
};
const handleClickOutsideModal = (event, ref, isModalOpen, setIsModalOpen) => {
    if (isModalOpen &&
        !event.target.closest('.cds-country-modal') &&
        !event.target.closest('.cds-country-picker__flag') &&
        !event.target.closest('.cds-country-picker__button')) {
        setIsModalOpen(false);
    }
    else {
        focusFirstCountryLink(ref);
    }
};
const handleEscape = (event, setIsModalOpen) => {
    if (event.key === 'Escape') {
        setIsModalOpen(false);
    }
};

const ICON_WORKAROUND_SEPARATOR = ';;';
const flag = (props) => {
    const [className, currentCountry, reformedCountryName, ariaLabel] = props.icon.split(ICON_WORKAROUND_SEPARATOR);
    return (jsx(ReactCountryFlag, { className: classNames(className, 'cds-country-picker__flag'), countryCode: currentCountry, svg: true, title: reformedCountryName, "aria-label": ariaLabel }));
};
const CountryPicker = ({ currentCountry, ariaLabel, buttonLabel, country, openIcon, closeIcon, className, }) => {
    const baseRef = useRef(null);
    const popperRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [windowWidth, setWindowWidth] = useState(0);
    const { styles, attributes } = usePopper(baseRef.current, popperRef.current, {
        placement: 'top-start',
    });
    const reformedCountry = getCountryData(currentCountry);
    useEffect(() => {
        const handleKeydown = (event) => {
            handleEscape(event, setIsModalOpen);
        };
        const handleClick = (event) => {
            handleClickOutsideModal(event, popperRef, isModalOpen, setIsModalOpen);
        };
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
        };
        document.addEventListener('keydown', handleKeydown);
        document.addEventListener('click', handleClick);
        window.addEventListener('resize', handleWindowResize);
        window.addEventListener('orientationchange', handleWindowResize);
        return () => {
            document.removeEventListener('keydown', handleKeydown);
            document.removeEventListener('click', handleClick);
            window.removeEventListener('resize', handleWindowResize);
            window.removeEventListener('orientationchange', handleWindowResize);
        };
    }, [isModalOpen]);
    const domDirection = useDomDirection();
    useEffect(() => {
        const isRtl = domDirection === ContentDirection.RTL;
        setContinentsWidth(popperRef, baseRef, isRtl);
        extendModalHeight(popperRef, baseRef, isRtl);
        addClassToWrappedElements(popperRef, isRtl);
    }, [windowWidth, domDirection]);
    return (reformedCountry === null || reformedCountry === void 0 ? void 0 : reformedCountry.name) ? (jsxs("div", Object.assign({ ref: baseRef, className: classNames(className, 'cds-country-picker') }, { children: [country && (jsx("div", Object.assign({ ref: popperRef, style: styles.popper }, attributes.popper, { className: classNames(className, 'cds-country-modal', isModalOpen ? '' : 'cds-country-picker__hidden'), role: "dialog" }, { children: jsx(CountryModal, { countries: country, className: "cds-country-picker__modal" }) }))), jsxs("div", Object.assign({ className: classNames(className, 'cds-country-picker__entry') }, { children: [buttonLabel && (jsx(Typography, { variant: "body", size: "l", weight: "bold", content: buttonLabel })), jsx(Button, Object.assign({ size: "large", className: classNames(className, 'cds-country-picker__button'), onClick: () => setIsModalOpen(!isModalOpen), iconPrefix: {
                            component: flag,
                            props: {
                                icon: [
                                    className,
                                    currentCountry,
                                    reformedCountry === null || reformedCountry === void 0 ? void 0 : reformedCountry.name,
                                    ariaLabel,
                                ].join(ICON_WORKAROUND_SEPARATOR),
                            },
                        }, iconSuffix: closeIcon.props &&
                            openIcon.props && {
                            props: isModalOpen ? closeIcon.props : openIcon.props,
                        } }, { children: reformedCountry.name }))] }))] }), `${windowWidth}-${domDirection}`)) : null;
};

export { CountryPicker };
